export const setAccessToken = ({ token, expires }: { token: string; expires: string }) => {
  const encodedToken = encodeURIComponent(token)
  let newTokenValue = `${process.env.AUTH_TOKEN_COOKIE_NAME}=${encodedToken}; expires=${expires}; path=/`
  newTokenValue += `;domain=${
    process.env.AUTH_TOKEN_COOKIE_DOMAIN || window.location.hostname.replace(/^[^.]*\.(?=\w+\.\w+$)/, '')
  };`
  document.cookie = newTokenValue
}
